import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from 'axios'
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import swal from 'sweetalert';

class AddSchools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            school_id: "",
            name: "",
            address: "",
            state: "",
            username: "",
            password: "",
            status: "checked"
        }
    }

    componentDidMount() { }

    handleChange(e) {
        if (e.target.name === "status") {
            this.setState({
                [e.target.name]: !this.state.status,
            })
        } else {
            this.setState({
                [e.target.name]: e.target.value,
                [e.target.name + 'Error']: false
            })
        }
    }

    validateData() {
        let error = false;
        if (this.state.school_id === "") {
            this.setState({ school_idError: true })
            error = true;
        }
        if (this.state.name === "") {
            this.setState({ nameError: true })
            error = true;
        }
        if (this.state.address === "") {
            this.setState({ addressError: true })
            error = true;
        }
        if (this.state.state === "") {
            this.setState({ stateError: true })
            error = true;
        }
        if (this.state.username === "") {
            this.setState({ usernameError: true })
            error = true;
        }
        if (this.state.password === "") {
            this.setState({ passwordError: true })
            error = true;
        }
        return error;
    }

    handleSubmit() {
        let validationError = this.validateData();
        if (validationError) {
            swal('Error in Adding School', 'Fill the required fields', 'error');
        } else {
            console.log('data', this.state);
            axios.post(`${BASEURL}/api/v1/school`, this.state)
                .then(res => {
                    if (res.status === 200) {
                        console.log('res.data', res.data);
                        swal("Success", "School Added successfully", "success")
                            .then(function () {
                                window.location = "schools";
                            })
                    } else {
                        console.log('res', res)
                    }
                })
                .catch((err) => {
                    console.log('index key', err.response)
                    if(err.response.data.includes('duplicate key') && err.response.data.includes('school_id_1'))
                    swal('Error in Adding School', 'School Id already exists', 'error');
                    if(err.response.data.includes('duplicate key') && err.response.data.includes('username_1'))
                    swal('Error in Adding School', 'Username already exists', 'error');
                    console.log('Create School Error', err);
                })
        }
    }

    render() {
        return (
            <div id="wrapper">
                <Sidebar act="schools" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Schools" breadcrumbItems={["Test Generator", { label: "Schools", path: "schools" }, "Add New School"]} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <div className="row">
                                                {/* <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="status" className="form-label">Status</label><br></br>
                                                        <input type="checkbox" id="switch1" name="status" data-switch="bool" checked={this.state.status} onChange={(e) => this.handleChange(e)} />
                                                        <label htmlFor="switch1" data-on-label="Active" data-off-label="Inactive" />
                                                    </div>
                                                </div> */}
                                                <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="school_id" className="form-label">School Id <span className="text-danger">*</span></label>
                                                        <input type="text" id="school_id" className="form-control" onChange={(e) => this.handleChange(e)}
                                                            name="school_id" placeholder="Enter School Id"
                                                            value={this.state.school_id} />
                                                        {this.state.school_idError ? <p className="errTxt">* required</p> : ''}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="schoolname" className="form-label">Name <span className="text-danger">*</span></label>
                                                        <input type="text" id="schoolname" className="form-control" onChange={(e) => this.handleChange(e)}
                                                            name="name" placeholder="Enter School Name"
                                                            value={this.state.name} />
                                                        {this.state.nameError ? <p className="errTxt">* required</p> : ''}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="Address" className="form-label">Address <span className="text-danger">*</span></label>
                                                        <input type="text" id="Address" className="form-control"
                                                            onChange={(e) => this.handleChange(e)}
                                                            name="address" placeholder="Enter Address" value={this.state.address} />
                                                        {this.state.addressError ? <p className="errTxt">* required</p> : ''}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="state" className="form-label">State <span className="text-danger">*</span></label>
                                                        <select name="state" id="state" className="form-select" value={this.state.state} onChange={(e) => this.handleChange(e)} >
                                                            <option value="">Select State</option>
                                                            <option value="Andhra Pradesh">Andhra Pradesh</option>
                                                            <option value="Telangana">Telangana</option>
                                                            <option value="Karnataka">Karnataka</option>
                                                            <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                                            <option value="Assam">Assam</option>
                                                            <option value="Bihar">Bihar</option>
                                                            <option value="Chandigarh">Chandigarh</option>
                                                            <option value="Chhattisgarh">Chhattisgarh</option>
                                                            <option value="Delhi">Delhi</option>
                                                            <option value="Puducherry">Puducherry</option>
                                                            <option value="Goa">Goa</option>
                                                            <option value="Gujarat">Gujarat</option>
                                                            <option value="Haryana">Haryana</option>
                                                            <option value="Himachal Pradesh">Himachal Pradesh</option>
                                                            <option value="Jharkhand">Jharkhand</option>
                                                            <option value="Kerala">Kerala</option>
                                                            <option value="Madhya Pradesh">Madhya Pradesh</option>
                                                            <option value="Maharashtra">Maharashtra</option>
                                                            <option value="Manipur">Manipur</option>
                                                            <option value="Meghalaya">Meghalaya</option>
                                                            <option value="Mizoram">Mizoram</option>
                                                            <option value="Nagaland">Nagaland</option>
                                                            <option value="Odisha">Odisha</option>
                                                            <option value="Punjab">Punjab</option>
                                                            <option value="Rajasthan">Rajasthan</option>
                                                            <option value="Sikkim">Sikkim</option>
                                                            <option value="Tamil Nadu">Tamil Nadu</option>
                                                            <option value="Tripura">Tripura</option>
                                                            <option value="Uttar Pradesh">Uttar Pradesh</option>
                                                            <option value="Uttarakhand">Uttarakhand</option>
                                                            <option value="West Bengal">West Bengal</option>
                                                        </select>
                                                        {this.state.stateError ? <p className="errTxt">* required</p> : ''}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="username" className="form-label">Username <span className="text-danger">*</span></label>
                                                        <input type="text" id="username" className="form-control"
                                                            onChange={(e) => this.handleChange(e)}
                                                            name="username" placeholder="Enter Username" value={this.state.username} />
                                                        {this.state.usernameError ? <p className="errTxt">* required</p> : ''}
                                                    </div>
                                                </div>
                                                <div className="col-xl-4">
                                                    <div className="mb-3">
                                                        <label htmlFor="password" className="form-label">Password <span className="text-danger">*</span></label>
                                                        <input type="text" id="password" className="form-control"
                                                            onChange={(e) => this.handleChange(e)}
                                                            name="password" placeholder="Enter Password" value={this.state.password} />
                                                        {this.state.passwordError ? <p className="errTxt">* required</p> : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="submit" class="btn btn-customprimary" onClick={() => this.handleSubmit()}>Submit</button>
                                            {/* end row */}
                                        </div> {/* end card-body */}
                                    </div> {/* end card*/}
                                </div> {/* end col*/}
                            </div>
                            {/* end row*/}
                        </div>
                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>
            </div>
        )
    }
}

export default AddSchools;